import React from 'react';

const AnimatedImage = ({ 
  src, 
  alt, 
  className = "", 
  containerClassName = "",
  children,
  type = "default" // "default", "robot", "gradient-box"
}) => {
  if (type === "robot") {
    return (
      <div className={`w-full max-w-md h-80 flex items-center justify-center relative ${containerClassName}`}>
        <div className="relative robot-animation w-full max-w-sm">
          <img 
            src={src} 
            alt={alt} 
            className={`w-full h-auto relative z-40 ${className}`}
          />
          {/* Rocket flames from left foot */}
          <div className="absolute bottom-[8%] left-[38%] z-30">
            <div className="flame flame-left-1"></div>
            <div className="flame flame-left-2"></div>
          </div>
          {/* Rocket flames from right foot */}
          <div className="absolute bottom-[8%] left-[58%] z-30">
            <div className="flame flame-right-1"></div>
            <div className="flame flame-right-2"></div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "gradient-box") {
    return (
      <div className="flex justify-center relative z-40">
        <div className="relative">
          <div className={`w-full max-w-md h-80 bg-gradient-to-br from-orange-400 to-[#163760] rounded-lg shadow-xl flex items-center justify-center hover:shadow-2xl transition-all duration-300 transform hover:scale-105 ${containerClassName}`}>
            {children}
          </div>
        </div>
      </div>
    );
  }

  if (type === "rotating-box") {
    return (
      <div className="flex justify-center relative z-40">
        <div className="relative">
          <div className={`w-80 h-80 bg-gradient-to-br from-orange-400 to-[#163760] rounded-lg transform rotate-6 hover:rotate-3 transition-all duration-300 hover:shadow-2xl ${containerClassName}`}></div>
          <div className="absolute inset-0 bg-white bg-opacity-10 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-opacity-20 transition-all duration-300">
            {children}
          </div>
        </div>
      </div>
    );
  }

  // Default image with hover animation
  return (
    <div className={`flex justify-center relative z-40 ${containerClassName}`}>
      <div className="relative group">
        <img 
          src={src} 
          alt={alt} 
          className={`rounded-lg shadow-xl transition-all duration-300 transform group-hover:scale-105 group-hover:shadow-2xl ${className}`}
        />
        {children}
      </div>
    </div>
  );
};

export default AnimatedImage; 